import type { LoginOptions } from "@dotcom/oauthjs";
import { Environment, environment } from "../constants/environment";
import { ItgConfig } from "@ceeferenderer/itg-renderer-sdk";

type PickRequired<T, K extends keyof T> = Partial<Omit<T, K>> & Required<Pick<T, K>>;
type PartialItgConfig = PickRequired<ItgConfig, "URL">;
type PartialOauthConfig = PickRequired<LoginOptions, "clientId">;
type Urls = Record<"xfinity-assistant" | "datalayer" | "logger" | "typeahead", string>;

export type EnvironmentConfig = {
  itgConfig: PartialItgConfig;
  oauthConfig: PartialOauthConfig;
  queryParams?: Record<string, unknown>;
  urls: Urls;
};

// URLs
const urlsBase = {
  typeahead: "https://api.sc.xfinity.com/address/typeahead",
  "xfinity-assistant": "https://www.xfinity.com/xfinityassistant/",
};
const urlsProd: Urls = {
  ...urlsBase,
  datalayer: "https://static.cimcontent.net/data-layer/?appID=resi_support_fe",
  logger: "https://api-support.xfinity.com/logger/",
};
const urlsPreProd: Urls = {
  ...urlsBase,
  datalayer: "https://static.cimcontent.net/data-layer/nonprod?appID=resi_support_fe",
  logger: "https://api-support-preprod.xfinity.com/logger/",
};
const urlsLower: Urls = {
  ...urlsBase,
  datalayer: "https://static.cimcontent.net/data-layer/nonprod?appID=resi_support_fe",
  logger: "https://api-support-test.xfinity.com/logger",
  typeahead: "https://api-staging.sc.xfinity.com/address/typeahead",
};

// ITG Config
const itgConfigLower = {
  URL: "https://itgprocessgateway-design-uat.codebig2.net",
};

// ITG Config
const itgConfigPreProduction = {
  URL: "https://itgprocessgateway-uat.codebig2.net",
};

// ITG Config
const itgConfigProduction = {
  URL: "https://itgprocessgateway-ccp-prod.codebig2.net",
};

const envConfigs: Record<Environment, EnvironmentConfig> = {
  dev: {
    itgConfig: itgConfigLower,
    oauthConfig: {
      clientId: "resi-help-dev7",
    },
    urls: urlsLower,
  },
  local: {
    itgConfig: itgConfigLower,
    oauthConfig: {
      clientId: "help-local",
    },
    urls: urlsLower,
  },
  preproduction: {
    itgConfig: itgConfigPreProduction,
    oauthConfig: {
      clientId: "resi-help-int",
    },
    urls: urlsPreProd,
  },
  production: {
    itgConfig: itgConfigProduction,
    oauthConfig: {
      clientId: "resi-help-prod",
    },
    urls: urlsProd,
  },
  qa: {
    itgConfig: itgConfigLower,
    oauthConfig: {
      clientId: "resi-help-qa7",
    },
    urls: urlsLower,
  },
};

export const envConfig = envConfigs[environment];
